import * as React from 'react';
import styled from 'styled-components/macro';
import { theme } from 'lib/style';
import { Modal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';

const ModalItem = styled.div`
  box-sizing: border-box;
  width: 600px;
  padding: 32px;
  min-height: 208px;
  background-color: #fff;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  color: ${theme.palette.black_1_100};
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${theme.palette.black_1_100};
  margin: 0;
`;

const CloseButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${theme.palette.coal};
  &:hover {
    cursor: pointer;
  }
`;

const Content = styled.div`
  margin-top: 32px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.palette.black};
`;

const ButtonsWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  gap: 8px;
`;

type Props = {
  onClickPrimaryButton: () => void;
  onClickSecondaryButton: () => void;
  handleModalClose: () => void;
};

export const ModalDeleteQuotePrompt = ({
  onClickSecondaryButton,
  onClickPrimaryButton,
  handleModalClose,
}: Props) => {
  const title = 'Delete Quote Data';
  const text = 'Are you sure you want to delete all data from the Quote?';
  const primaryButtonText = 'Yes, Delete Quote';
  const secondaryButtonText = 'No, Keep Quote';
  return (
    <Modal disableFullScreen={true} style={{ position: 'fixed' }}>
      <ModalItem>
        <Header>
          <Title>{title}</Title>
          <CloseButtonWrapper>
            <IoMdClose size={24} onClick={handleModalClose} />
          </CloseButtonWrapper>
        </Header>
        <Content>{text}</Content>
        <ButtonsWrapper>
          <Button
            variant='secondary'
            text={secondaryButtonText}
            onClick={onClickSecondaryButton}
          />
          <Button
            variant='red'
            text={primaryButtonText}
            onClick={onClickPrimaryButton}
          />
        </ButtonsWrapper>
      </ModalItem>
    </Modal>
  );
};
